<template>
  <div class="blogPromoted">
    <div class="blogPromoted__header" v-if="title">
      <h2 class="blogPromoted__title">
        {{ title }}
      </h2>
      <div class="blogPromoted__headerLink">
        <border-link :to="localePath({ name: 'blog' })" text="Zobacz więcej" v-if="showAll" />
      </div>
    </div>
    <div class="blogPromoted__inner">
      <div class="blogPromoted__col">
        <div class="blogPromoted__item">
          <blog-big-tile :item="items[0]" horizontal :lazy="lazy" />
        </div>
      </div>
      <div class="blogPromoted__col">
        <div class="blogPromoted__smallItem">
          <blog-tile :item="items[1]" horizontal :lazy="lazy" />
        </div>
        <div class="blogPromoted__smallItem">
          <blog-tile :item="items[2]" horizontal :lazy="lazy" />
        </div>
      </div>
    </div>
    <div class="blogPromoted__mobile" v-if="showAll">
      <v-button
        :to="localePath({ name: 'blog' })"
        small-height
        text="Wszystkie wpisy"
        theme="purple"
      />
    </div>
  </div>
</template>

<script>
import BlogBigTile from '~/components/Blog/BlogBigTile';
import BlogTile from '~/components/Blog/BlogTile';
import BorderLink from '~/components/BorderLink';
import VButton from '~/components/VButton';

export default {
  name: 'BlogPromoted',
  components: {
    BlogBigTile,
    BlogTile,
    BorderLink,
    VButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.blogPromoted {
  &__header {
    margin-bottom: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__headerLink {
    @include rwd('tablet') {
      display: none;
    }
  }

  &__title {
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;

    @include rwd('tablet') {
      width: 100%;
      text-align: center;
      font-size: 3rem;
      line-height: 3.8rem;
    }
  }

  &__inner {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -20px;
  }

  &__col {
    flex-direction: column;
    display: flex;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 20px;

    @include rwd('large-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__item {
    height: 100%;

    @include rwd('large-tablet') {
      margin-bottom: 4rem;
    }
  }

  &__smallItem {
    margin-bottom: 4rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__mobile {
    display: none;
    justify-content: center;
    margin-top: 3rem;

    @include rwd('tablet') {
      display: flex;
    }
  }
}
</style>
